import dayjs from "dayjs";
import "dayjs/locale/bg";
import "dayjs/locale/da";
import "dayjs/locale/de";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/et";
import "dayjs/locale/fi";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/lt";
import "dayjs/locale/lv";
import "dayjs/locale/nl";
import "dayjs/locale/pl";
import "dayjs/locale/ro";
import "dayjs/locale/ru";
import "dayjs/locale/sv";
import relativeTime from "dayjs/plugin/relativeTime";
import i18next, { t } from "i18next";

dayjs.extend(relativeTime);

const DAYJS_LOCALE_BY_LANGUAGE: Record<string, string> = {
  dk: "da",
  ee: "et",
  se: "sv",
};

export const getDayjsLocale = (language: string) =>
  DAYJS_LOCALE_BY_LANGUAGE[language] ?? language;

export const dateToUTC = (date: string | Date | null) => {
  return dayjs.utc(date);
};

export const utcToLocal = (date: Date | string): Date => {
  const newDate = new Date(date);
  return new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
};

export const localToUtc = (date: Date | string): Date => {
  const newDate = new Date(date);
  return new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60000);
};

export const formatDate = (date: string | Date | null) => {
  if (date === null) {
    return null;
  }

  const parsedDate = dateToUTC(date);
  const hour = parsedDate.format("HH");
  const min = parsedDate.format("mm");

  if (parsedDate.isToday()) return `${t("common:today")} ${hour}:${min}`;

  if (parsedDate.isTomorrow()) return `${t("common:tomorrow")} ${hour}:${min}`;

  return parsedDate.format("DD.MM.YYYY HH:mm");
};

export const formatLocalDate = (date: string | Date | null | undefined) => {
  if (!date) return null;

  const parsedDate = dayjs(date);
  const hour = parsedDate.format("HH");
  const min = parsedDate.format("mm");

  if (parsedDate.isToday()) return `${t("common:today")} ${hour}:${min}`;

  if (parsedDate.isTomorrow()) return `${t("common:tomorrow")} ${hour}:${min}`;

  return parsedDate.format("DD.MM.YYYY HH:mm");
};

export const formatRelativeTime = (date: string | Date) =>
  dayjs(date)
    .locale(getDayjsLocale(i18next.resolvedLanguage ?? i18next.language))
    .fromNow();
